import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2433ca46"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "left" }
const _hoisted_2 = { class: "right" }
const _hoisted_3 = { class: "chat-wrapper" }

import ControlButton from '@/components/room/ControlButton.vue'
import DeviceButtonOption from '@/components/room/DeviceButtonOption.vue'
import useNotify from '@/composables/useNotify'
import { useDeviceStore } from '@/stores'
import { Engine } from '@/types/enums/room.enum'
import { IParticipantCapabilities } from '@/types/interfaces/participant.interface'
import { PropType, ref } from 'vue'

export type DeviceChange = 'mic' | 'cam' | 'audio'
export interface IChangeSetting {
  type: DeviceChange
  deviceId: string
}

interface IShowMessage {
  mic: boolean
  cam: boolean
  audio: boolean
}

interface RoomControlEmits {
  (e: 'toggle-cam', value: boolean): void
  (e: 'toggle-mic', value: boolean): void
  (e: 'toggle-doc', value: boolean): void
  (e: 'toggle-whiteboard', value: boolean): void
  (e: 'toggle-screen-share', value: boolean): void
  (e: 'toggle-chat', value: boolean): void
  (e: 'toggle-sticker', value: boolean): void
  (e: 'toggle-game', value: boolean): void
  (e: 'toggle-help', value: boolean): void
  (e: 'switch-device', value: IChangeSetting): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'RoomControl',
  props: {
  nCompartments: {
    type: Number,
    default: 1,
  },
  userPermissions: {
    type: Object as PropType<IParticipantCapabilities>,
    required: true,
  },
  isSmall: {
    type: Boolean,
    default: false,
  },
  cameraEnable: {
    type: Boolean,
    default: false,
  },
  microphoneEnable: {
    type: Boolean,
    default: false,
  },
  documentEnable: {
    type: Boolean,
    default: false,
  },
  whiteboardEnable: {
    type: Boolean,
    default: false,
  },
  screenShareEnable: {
    type: Boolean,
    default: false,
  },
  stickerEnable: {
    type: Boolean,
    default: false,
  },
  chatEnable: {
    type: Boolean,
    default: false,
  },
  gameEnable: {
    type: Boolean,
    default: false,
  },
  screenShareShow: {
    type: Boolean,
    default: true,
  },
  chatNotifyCount: {
    type: Number,
    default: 0,
  },
  engine: {
    type: String as PropType<Engine>,
    default: () => Engine.WHEREBY,
  },
},
  emits: ["toggle-cam", "toggle-mic", "toggle-doc", "toggle-whiteboard", "toggle-screen-share", "toggle-chat", "toggle-sticker", "toggle-game", "toggle-help", "switch-device"],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const deviceStore = useDeviceStore()
const notification = useNotify()

const showWarning = ref<IShowMessage>({ mic: false, cam: false, audio: false })

const triggerShowWarning = (type: DeviceChange, withMessage?: string) => {
  if (withMessage) return (showWarning.value[type] = true)
  else showWarning.value[type] = false
}

const onDeviceChange = (deviceId: string, type: DeviceChange) => {
  emit('switch-device', { type, deviceId })
}

const toggleCamera = () => {
  if (deviceStore.allowedCamera) {
    emit('toggle-cam', !props.cameraEnable)
  } else {
    notification.warning({
      text: deviceStore.videoErrorMsg || 'Please allow camera',
      component: 'svg-icon',
      icon: 'warning',
    })
  }
}
const toggleMicrophone = () => {
  if (deviceStore.allowedMicrophone) {
    emit('toggle-mic', !props.microphoneEnable)
  } else {
    notification.warning({
      text: deviceStore.micErrorMsg || 'Please allow microphone',
      component: 'svg-icon',
      icon: 'warning',
    })
  }
}

return (_ctx: any,_cache: any) => {
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["room-footer", { '-small': __props.isSmall }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (__props.userPermissions?.publishableTracks?.cam)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass({ 'ext-gap': !_unref(deviceStore).videoErrorMsg && _unref(deviceStore).videoInputDevices.length })
          }, [
            _createVNode(_component_Popper, {
              show: showWarning.value.cam,
              hover: true,
              arrow: true,
              content: _unref(deviceStore).videoErrorMsg,
              onMouseover: _cache[1] || (_cache[1] = ($event: any) => (triggerShowWarning('cam', _unref(deviceStore).videoErrorMsg))),
              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (showWarning.value.cam = false))
            }, {
              default: _withCtx(() => [
                _createVNode(DeviceButtonOption, {
                  value: _unref(deviceStore).maskSelectedVideo,
                  "is-enable": __props.cameraEnable,
                  options: _unref(deviceStore).videoErrorMsg ? [] : _unref(deviceStore).videoInputDevices,
                  onChangeDevice: _cache[0] || (_cache[0] = ($event: any) => (onDeviceChange($event, 'cam')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(ControlButton, {
                      name: "Cam",
                      icon: "cam",
                      "icon-disabled": "cam-disabled",
                      "is-ready": true,
                      disabled: !__props.cameraEnable || !_unref(deviceStore).allowedCamera,
                      "is-danger-disabled": "",
                      "is-warning": !!_unref(deviceStore).videoErrorMsg,
                      onClick: toggleCamera
                    }, null, 8, ["disabled", "is-warning"])
                  ]),
                  _: 1
                }, 8, ["value", "is-enable", "options"])
              ]),
              _: 1
            }, 8, ["show", "content"])
          ], 2))
        : _createCommentVNode("", true),
      (__props.userPermissions?.publishableTracks?.mic)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass({ 'ext-gap': !_unref(deviceStore).micErrorMsg && _unref(deviceStore).audioInputDevices.length })
          }, [
            _createVNode(_component_Popper, {
              show: showWarning.value.mic,
              hover: true,
              arrow: true,
              content: _unref(deviceStore).micErrorMsg,
              onMouseover: _cache[4] || (_cache[4] = ($event: any) => (triggerShowWarning('mic', _unref(deviceStore).micErrorMsg))),
              onMouseleave: _cache[5] || (_cache[5] = ($event: any) => (showWarning.value.mic = false))
            }, {
              default: _withCtx(() => [
                _createVNode(DeviceButtonOption, {
                  value: _unref(deviceStore).maskSelectedAudio,
                  "is-enable": __props.microphoneEnable,
                  options: _unref(deviceStore).micErrorMsg ? [] : _unref(deviceStore).audioInputDevices,
                  onChangeDevice: _cache[3] || (_cache[3] = ($event: any) => (onDeviceChange($event, 'mic')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(ControlButton, {
                      name: "Mic",
                      icon: "mic",
                      "icon-disabled": "mic-disabled",
                      disabled: !__props.microphoneEnable || !_unref(deviceStore).allowedMicrophone,
                      "is-danger-disabled": "",
                      "is-warning": !!_unref(deviceStore).micErrorMsg,
                      onClick: toggleMicrophone
                    }, null, 8, ["disabled", "is-warning"])
                  ]),
                  _: 1
                }, 8, ["value", "is-enable", "options"])
              ]),
              _: 1
            }, 8, ["show", "content"])
          ], 2))
        : _createCommentVNode("", true),
      (_unref(deviceStore).canSetSpeaker)
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: _normalizeClass({
          'ext-gap': !_unref(deviceStore).speakerErrorMsg && _unref(deviceStore).audioOutputDevices.length,
        })
          }, [
            _createVNode(_component_Popper, {
              show: showWarning.value.audio,
              hover: true,
              arrow: true,
              content: _unref(deviceStore).speakerErrorMsg,
              onMouseover: _cache[7] || (_cache[7] = ($event: any) => (triggerShowWarning('audio', _unref(deviceStore).speakerErrorMsg))),
              onMouseleave: _cache[8] || (_cache[8] = ($event: any) => (showWarning.value.audio = false))
            }, {
              default: _withCtx(() => [
                _createVNode(DeviceButtonOption, {
                  value: _unref(deviceStore).maskSelectedSpeaker,
                  options: _unref(deviceStore).speakerErrorMsg ? [] : _unref(deviceStore).audioOutputDevices,
                  onChangeDevice: _cache[6] || (_cache[6] = ($event: any) => (onDeviceChange($event, 'audio')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(ControlButton, {
                      name: "Audio",
                      icon: "speaker",
                      disabled: false,
                      "is-warning": !!_unref(deviceStore).speakerErrorMsg,
                      "is-danger-disabled": ""
                    }, null, 8, ["is-warning"])
                  ]),
                  _: 1
                }, 8, ["value", "options"])
              ]),
              _: 1
            }, 8, ["show", "content"])
          ], 2))
        : _createCommentVNode("", true),
      (__props.userPermissions?.doc && __props.engine !== _unref(Engine).VICOLLO)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 3,
            name: "Doc",
            icon: "doc",
            disabled: !__props.documentEnable,
            onClick: _cache[9] || (_cache[9] = ($event: any) => (emit('toggle-doc', !__props.documentEnable)))
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      (__props.userPermissions?.publishableTracks?.screenShare)
        ? _withDirectives((_openBlock(), _createBlock(ControlButton, {
            key: 4,
            name: "Screen",
            icon: "screen",
            disabled: !__props.screenShareEnable,
            onClick: _cache[10] || (_cache[10] = ($event: any) => (emit('toggle-screen-share', !__props.screenShareEnable)))
          }, null, 8, ["disabled"])), [
            [_vShow, __props.screenShareShow]
          ])
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_2, [
      (__props.userPermissions?.engder)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 0,
            name: "Game",
            icon: "game",
            disabled: !__props.gameEnable,
            "is-ready": __props.nCompartments == 1,
            onClick: _cache[11] || (_cache[11] = ($event: any) => (emit('toggle-game', !__props.gameEnable)))
          }, null, 8, ["disabled", "is-ready"]))
        : _createCommentVNode("", true),
      (__props.userPermissions?.sticker)
        ? (_openBlock(), _createBlock(ControlButton, {
            key: 1,
            name: "Sticker",
            icon: "sticker",
            disabled: !__props.stickerEnable,
            onClick: _cache[12] || (_cache[12] = ($event: any) => (emit('toggle-sticker', !__props.stickerEnable)))
          }, null, 8, ["disabled"]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_3, [
        (__props.userPermissions?.chat)
          ? (_openBlock(), _createBlock(ControlButton, {
              key: 0,
              name: "Chat",
              icon: "chat",
              disabled: !__props.chatEnable,
              badge: __props.chatNotifyCount > 0 ? `${__props.chatNotifyCount}` : '',
              onClick: _cache[13] || (_cache[13] = ($event: any) => (emit('toggle-chat', !__props.chatEnable)))
            }, null, 8, ["disabled", "badge"]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 2))
}
}

})